export function trim(s: string, c: string, leftOrRight: "l" | "r" = undefined) {
    if (c === "]") c = "\\]";
    if (c === "^") c = "\\^";
    if (c === "\\") c = "\\\\";

    if (leftOrRight === "r") return s.replace(new RegExp("[" + c + "]+$", "g"), "");
    if (leftOrRight === "l") return s.replace(new RegExp("^[" + c + "]+", "g"), "");
    return s.replace(new RegExp("^[" + c + "]+|[" + c + "]+$", "g"), "");
}

export function rtrim(s: string, c: string) {
    return trim(s, c, "r");
}

export function ltrim(s: string, c: string) {
    return trim(s, c, "l");
}
